import React, {Component} from "react";
class UseCases extends Component {
    render() { 
        return (
            <>
            
            <div className="container py-5 px-3 text-justify text-black">
                <div className="row justify-content-md-center">
                    <div className="col-md-12">
                        <h3 className="text-center text-dark">{this.props.content.details.name}</h3>
                    </div>
                    {
                        this.props.content.details.contents.map((res, id)=> {
                           
                            return (
                            <>
                             <div className="col-md-4 mb-4">
                                    <img src={res.image}></img>
                                    <p className="text-center">{res.title}</p>
                                </div>
                            </>
                            )
                        })
                    }
                   
                </div>
            </div>
            </>
        )
    }
}

export default UseCases;